import React from 'react';
import icon from './favicon.png';
import { Link } from 'react-router-dom';

function Footer() {
    const links = [
        { href: "/", label: "Bootstrap to Tailwind Converter" },
        { href: "/how", label: "How to Convert Bootstrap to Tailwind" },
        { href: "/contact", label: "Contact Us" },
        { href: "/privacy-policy", label: "Privacy Policy" },
    ];

    return (
        <footer className="bg-gray-900 text-gray-300 py-4 mt-5 w-full">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
                    <div className="flex flex-col items-start space-y-4 md:w-1/3">
                        <a href="/" className="flex items-center py-2">
                            <img className="w-10 mr-2" src={icon} alt="Windify Bootstrap to Tailwind Converter" />
                            <span className="font-semibold text-white text-xl">Windify</span>
                        </a>
                        <p className="text-sm text-gray-400 max-w-md">
                            Free Bootstrap to Tailwind CSS converter tool. Convert Bootstrap classes to Tailwind CSS instantly. 
                            Also supports Tailwind to Bootstrap conversion. Migrate from Bootstrap to Tailwind CSS with ease.
                        </p>
                    </div>
                    {/* ✅ FIXED: Removed invalid Tailwind class "md:w-9/5" — replaced with "md:w-auto" */}
                    <div className="flex flex-col md:flex-row md:items-center md:w-auto justify-between mt-6 md:mt-0">
                        <nav className="flex flex-col md:flex-row md:space-x-4 space-y-2 md:space-y-0" aria-label="Footer navigation">
                            {links.map((link, index) => (
                                <Link
                                    to={link.href}
                                    key={index}
                                    className="text-sm font-semibold text-gray-300 hover:text-blue-500 transition duration-300"
                                >
                                    {link.label}
                                </Link>
                            ))}
                        </nav>
                    </div>
                </div>

                <div className="border-t border-gray-700 pt-4 text-center">
                    <p className="text-sm">
                        &copy; {new Date().getFullYear()} Windify — Bootstrap to Tailwind CSS Converter. 
                        Free online migration tool. Built with ❤️ by{' '}
                        <a
                            href="https://www.linkedin.com/in/shahzaib-kesrani/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            Shahzaib Kesrani
                        </a>.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;